module.exports = __webpack_public_path__ + "static/media/shoe (2).3dd2c828.jpg";